<template>
  <v-toolbar dark color="cyan">
    <v-toolbar-title>{{title}}</v-toolbar-title>
    <v-spacer />
    <v-tooltip bottom v-for="(button, index) in buttons" :key="index">
      <v-btn flat icon slot="activator"
             :disabled="button.disabled"
             :to="button.to"
             @click.native="actionHandler(button)"
             v-if="renderButton(button)">
        <v-icon>{{button.icon}}</v-icon>
      </v-btn>
      <span>{{button.tooltip || button.label}}</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
export default {
  name: 'ChildToolbar',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    buttons: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    renderButton (button) {
      if (button.hasOwnProperty('render')) {
        return button.render
      } else {
        return true
      }
    },
    actionHandler (button) {
      if (button.hasOwnProperty('handler')) {
        button.handler()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChildToolbar.vue